/** @format */

import axios from "axios";

let axiosInstance = axios.create({
  timeout: 60000,
});

export const setupAuthInterceptor = (getAuthState, redirectUrl) => {
  axiosInstance.interceptors.request.use((req) => {
    if (req.url.indexOf("token") === -1 && req.url.indexOf("s3") === -1) {
      const authState = getAuthState();
      req.headers.access_token = authState.access_token;
      req.headers.Authorization = authState.id_token;
    }
    // Important: request interceptors **must** return the request.
    return req;
  });

  axiosInstance.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response.status === 401) {
        window.location.replace(redirectUrl);
      }
      throw err;
    }
  );
};

const OK_STATUSES = [200, 204];

const CONTENT_TYPES = {
  json: "application/json",
  form: "application/x-www-form-urlencoded",
};

export const apiTimeout = { timeout: 15000 };

export const defaultApiError = "Looks like there's a problem on our end, please try again";

export const isResponseOK = (response) => response && OK_STATUSES.includes(response.status);

export const getUserError = ({ response, apiMessages, defaultError = defaultApiError }) =>
  response && response.data ? apiMessages[response.data.message] || defaultError : defaultError;

const getAdditionalHeaders = (headers = {}) => ({
  ...headers,
});

export const getContentType = (type) => type || "json";

export const GET = async ({ endpoint, options = {} }) => {
  try {
    return await axiosInstance.get(process.env.REACT_APP_API_BASE_URL + endpoint, {
      headers: {
        ...getAdditionalHeaders(options.headers),
      },
      ...apiTimeout,
    });
  } catch (err) {
    return err
  }
};

export const POST = async ({ endpoint, payload = {}, options = {} }) => {
  try {
    let uri = endpoint;

    if (!options.fullUrl) {
      uri = process.env.REACT_APP_API_BASE_URL + endpoint;
    }

    return await axiosInstance.post(uri, payload, {
      headers: {
        "Content-Type": CONTENT_TYPES[getContentType(options.type)],
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        ...getAdditionalHeaders(options.headers),
      },
      ...apiTimeout,
    });
  } catch (err) {
    return err.response;
  }
};

export const DELETE = async ({ endpoint, options = {} }) => {
  try {
    return await axiosInstance.delete(process.env.REACT_APP_API_BASE_URL + endpoint, {
      headers: {
        ...getAdditionalHeaders(options.headers),
      },
      ...apiTimeout,
    });
  } catch (err) {
    return err.response;
  }
};

export const PATCH = async ({ endpoint, payload = {}, options = {} }) => {
  try {
    return await axiosInstance.patch(process.env.REACT_APP_API_BASE_URL + endpoint, payload, {
      headers: {
        "Content-Type": "application/json-patch+json",
        ...getAdditionalHeaders(options.headers),
      },
      ...apiTimeout,
    });
  } catch (err) {
    return err.response;
  }
};

export const PUT = async ({ endpoint, payload = {}, options = {} }) => {
  try {
    return await axiosInstance.put(process.env.REACT_APP_API_BASE_URL + endpoint, payload, {
      headers: {
        "Content-Type": "application/json",
        ...getAdditionalHeaders(options.headers),
      },
      ...apiTimeout,
    });
  } catch (err) {
    return err.response;
  }
};

export const S3_DOC_PUT = async ({ endpoint, payload = {} }) => {
  try {
    return await axiosInstance.put(endpoint, payload, {
      headers: {
        "Content-Type": "application/pdf",
      },
    });
  } catch (err) {
    return err.response;
  }
};

export default {
  GET,
  POST,
  DELETE,
  PUT,
  S3_DOC_PUT,
  PATCH,
  isResponseOK,
  getUserError,
};
